import {Router, NavigationEnd} from "@angular/router";
declare let ga: Function;
export class GoogleAnalytics {
    constructor(private router: Router) {
        router.events.subscribe((val) => {
            if(val instanceof NavigationEnd) {

                if(typeof ga === "function") {
                    ga('send', 'pageview', val.url);
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/google-analytics.ts